/* 投诉-模块API */

import { GET, POST, PUT, DELETE, download, uploading, POSTFormData, EXPORT } from '@/request/http'

//投诉page
export const pageComplaint = p => POST('/complaint/cpcomplaintinfo/query', p, 3)
//投诉分类page
export const pageComplaintType = p => POST('/complaint/cpcomplainttype/querypc', p, 3)
//投诉分类save
export const saveComplaintType = p => POST('/complaint/cpcomplainttype/add', p, 3)
//投诉分类update
export const updateComplaintType = p => POST('/complaint/cpcomplainttype/update', p, 3)
//投诉分类delete
export const deleteComplaintType = p => POST('/complaint/cpcomplainttype/delete', p, 3)

/*
投诉分类管理
*/

//新增咨询分类
export const addComplaintType = p => POST('/consult/consultclassify/save', p, 3)
//删除咨询分类
export const removeComplaintType = p => DELETE('/consult/consultclassify/{id}/remove', p, 3)
//修改咨询分类
export const updateComplaintTypeInfo = p => PUT('/consult/consultclassify/update', p, 3)
//查询咨询分类列表
export const getComplaintType = p => GET('/consult/consultclassify/list', p, 3)
//根据用户范围查询咨询分类列表
export const getUserComplaintType = p => GET('/consult/consultclassify/listByScope', p, 3)
/*
投诉管理
*/

//回复咨询
export const replyComplaint = p => POST('/consult/reply/submit/result', p, 3)
//分页查询所有咨询
export const getComplaintPage = p => GET('/consult/management/all/consult', p, 3)
//根据咨询单号查询咨询详情
export const seeNoComplaint = p => GET('/consult/management/get/{consultno}', p, 3)
//查询我的待回复列表
export const waitMyComplaint = p => GET('/consult/reply/waitreply/page', p, 3)
//导出咨询记录
export const exportComplaint = p => EXPORT('/consult/export', p, 3)

//管理范围
//回复咨询
export const addComplaintScope = p => POST('/consult/scope/add', p, 3)
//查询管理范围
export const getComplainPage = p => GET('/consult/scope/all', p, 3)
// 查询管理范围信息
export const getComplainScopeInfo = p => GET('/consult/scope/{consultScopeId}/scopeInfo', p, 3)
// 编辑范围名称
export const updateComplainScopeName = p => PUT('/consult/scope/{consultScopeId}/name', p, 3)
// 编辑范围位置
export const updateComplainScopeLocation = p => PUT('/consult/scope/location', p, 3)
// 编辑范围投诉类型
export const updateComplainScopeType = p => PUT('/consult/scope/classify', p, 3)
// 删除范围
export const delComplainScope = p => DELETE('/consult/scope/{consultscopeId}/remove', p, 3)



// WEBPACK FOOTER //
// ./src/api/modules/complaint.js